<template>
  <div class="w-full h-full absolute bg-black/50 text-center md:py-4">
    <div
      v-if="editablePolls.length > 0"
      ref="popup"
      class="bg-white md:rounded-lg md:w-5/6 inline-block w-full relative text-left max-h-full overflow-auto"
    >
      <font-awesome-icon
        icon="xmark"
        class="text-3xl text-primary cursor-pointer float-right m-3"
        @click="$emit('close')"
      />
      <div v-for="poll in editablePolls" :key="poll" class="mb-4 border rounded-lg p-4 shadow-sm">
        <span class="text-2xl font-bold">{{ poll.title }}</span>

        <pre class="whitespace-break-spaces font-sans text-left w-full">{{
          poll.description
        }}</pre>

        <div :class="'grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3'">
          <div v-for="option in poll.options" :key="option" class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-gray-50 mb-2" :class="{ 'bg-blue-50 border-blue-300': !poll.multiple && poll.answer === option.id }" @click="selectOption(poll, option)">
            <label :for="poll.id + '_' + option.id" class="flex items-center gap-3 cursor-pointer flex-1" @click.stop>
              <input v-if="poll.multiple" type="checkbox" :id="poll.id + '_' + option.id" :name="poll.title" v-model="option.selected" />
              <input v-else type="radio" :id="poll.id + '_' + option.id" :name="poll.title" :value="option.id" :checked="poll.answer === option.id" @change="poll.answer = option.id" />
              <span>{{ option.answer }}</span>
            </label>
            <input v-if="option.freetext" v-model="poll.freetext" class="w-auto py-1" type="text" :placeholder="$t('Freitext')" @click.stop />
          </div>
        </div>
        <div v-if="poll.comments">
          <label>{{$t('Kommentar')}}</label>
          <input type="text" v-model="poll.comment" :placeholder="$t('Kommentar eingeben...')" />
        </div>
      </div>

      <div class="w-full text-center">
        <button class="green my-4" @click="saveAnswers()">{{$t('Speichern')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/API";

export default {
  emits: ["toast", "close"],
  props: {
    polls: Array,
    contract:Object
  },

  data() {
    return {
      editablePolls: [],
    };
  },
  methods: {
    selectOption(poll, option) {
      if (!poll.multiple) {
        poll.answer = option.id;
      }
    },
    saveAnswers() {
      let polls = {};
      this.editablePolls.forEach((poll) => {
        polls[poll.id] = {
          answers: [],
          comment: poll.comment,
        };
        if (!poll.multiple) {
          polls[poll.id].answer = poll.answer;
        }
        if (poll.freetext) {
          polls[poll.id].freetext = poll.freetext;
        }
        poll.options.forEach((option) => {
          if (poll.multiple) {
            if (option.selected) {
              polls[poll.id].answers.push(option.id);
            }
          }
        });
        if (poll.freetext) {
          polls[poll.id].freetext = poll.freetext;
        }
      });
      API.answerPolls(this.contract.id, polls, (r, status) => {
        if (status === 200) {
          this.$emit("toast", "Angaben gesendet!");
          this.$emit("close");
        }
      });
    },
  },
  mounted() {
    if (this.polls) {
      this.editablePolls = this.polls;
      this.editablePolls.forEach((poll) => {
        if (poll.multiple) {
          poll.options.forEach((option) => {
            option.selected = poll.answers.includes(option.id)?'on':false;
            if (option.selected) {
              setTimeout(() => {
                document.getElementById(poll.id + "_" + option.id).checked =
                  option.selected;
              }, 500);
            }
          });
        } else if (poll.answers.length == 1) {
          poll.answer = poll.answers[0];
        }
      });
    }
  },
};
</script>
